@if ((isInitializing$ | async) === false) {
    <router-outlet></router-outlet>
} @else {
    <p i18n>Initializing...</p>
}
